// A dónde volver después de entrar (`?next=`).
//
// ⚠️ Vive en su PROPIO módulo, sin importar nada, y no dentro de `Login.tsx`.
// El test lo necesita, y `Login.tsx` arrastra `lib/supabase.ts` → `createClient`,
// que revienta con «supabaseKey is required» donde no hay variables de entorno.
// En el Mac pasaba porque existe `web/.env.local`; en CI no, y el panel se puso
// rojo. Una función pura que hay que probar no puede colgar de un cliente de red.
//
// Lo que decide: solo rutas de esta misma app. Aceptar cualquier destino sería
// una redirección abierta — un enlace NUESTRO que lleva a otro sitio, que es
// justo lo que necesita un phishing creíble con nuestra marca.
export function destinoSeguro(next: string | null): string {
  if (!next || !next.startsWith("/")) return "/";
  // `//evil.com` y `/\evil.com` son URLs absolutas para el navegador.
  if (next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}
